import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import x from 'core/assets/svg/x.svg';
import done from 'core/assets/svg/done.svg';
import useStyles from '../../../dialog.styles';

const statusToIconMap = {
  success: done,
  failed: x
};

export const DriverCard = observer(function DriverCard({ driver, status }) {
  const classes = useStyles();
  return (
    <Card type="primary" className={classes.driverCard}>
      <Grid container xs={12} justifyContent="space-between" alignItems="center">
        <Grid container item xs={6} alignItems="center">
          <Grid item>
            <Label
              type="infoSubtitle"
              style={{
                display: 'inline',
                marginLeft: 20
              }}
            >
              {driver.firstName} {driver.lastName}
            </Label>
          </Grid>
        </Grid>
        <Grid item>{status ? <img src={statusToIconMap[status]} alt="" /> : ''}</Grid>
      </Grid>
    </Card>
  );
});

DriverCard.propTypes = {
  driver: PropTypes.object.isRequired,
  status: PropTypes.oneOf(['success', 'failed'])
};
